// ProgressBar component - displays "X out of Y" with pill indicators
import * as styles from './ProgressBar.css';
import { toArray } from '@client/new/helpers/general';

export type ProgressBarProps = {
  current: number; // 1-indexed current step
  total: number;
};

export const ProgressBar = ({ current, total }: ProgressBarProps) => {
  // Convert to 0-indexed for comparison
  const currentIndex = current - 1;

  const getPillClassName = (index: number): string => {
    const classNames = [styles.pill];

    // Show completed for steps before current, current for active step
    // Don't show completed for future steps even if answered (after going back)
    if (index < currentIndex) {
      classNames.push(styles.pillCompleted);
    } else if (index === currentIndex) {
      classNames.push(styles.pillCurrent);
    }

    return classNames.join(' ');
  };

  return (
    <div className={styles.container} data-testid="progress-bar">
      <span className={styles.label}>
        {current} out of {total}
      </span>
      <div className={styles.pillsContainer}>
        {toArray(total, (index) => (
          <div
            key={index}
            className={getPillClassName(index)}
            data-testid={`progress-pill-${index}`}
          />
        ))}
      </div>
    </div>
  );
};
